"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _headerMessages = require("./headerMessages");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BillingInfoHeader = function BillingInfoHeader(_ref) {
  var block = _ref.block,
    inputRef = _ref.inputRef;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var strings = block.strings || {};
  var headerText = strings.text || formatMessage(_headerMessages.headerMessages.billingInfoHeaderText);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__billing-info__header",
    ref: inputRef
  }, headerText);
};
BillingInfoHeader.propTypes = {
  block: _propTypes.default.object.isRequired,
  inputRef: _propTypes.default.func.isRequired
};
var _default = BillingInfoHeader;
exports.default = _default;